import { CampaignSurveyLoader } from './components/campaign/CampaignSurveyLoader'
import { ThemeProvider } from './components/campaign/Theme'
import { useSurveyProps } from './hooks/useSurveyProps'
import * as formStyles from './misc/styled'

if (formStyles.avoid_tree_shaking === 1) {
  // Preview treeshake
}

const CampaignRoot = () => {
  const props = useSurveyProps()
  return (
    <ThemeProvider>
      <CampaignSurveyLoader {...props} />
    </ThemeProvider>
  )
}

export default CampaignRoot
